module.exports = __webpack_public_path__ + "static/floppy_knights-1346d712b25c02f49f8dbb807cb9aaaa.webp";